'use strict';

var _createForOfIteratorHelper = require("/tmp/build_a9c3e3e2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");
var path = require('path');
var pathExists = require('path-exists');
var pLocate = require('p-locate');
module.exports = function (iterable, options) {
  options = Object.assign({
    cwd: process.cwd()
  }, options);
  return pLocate(iterable, function (el) {
    return pathExists(path.resolve(options.cwd, el));
  }, options);
};
module.exports.sync = function (iterable, options) {
  options = Object.assign({
    cwd: process.cwd()
  }, options);
  var _iterator = _createForOfIteratorHelper(iterable),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var el = _step.value;
      if (pathExists.sync(path.resolve(options.cwd, el))) {
        return el;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};